// Diagnostics for connection and image loading, kept in local storage so a
// session that went wrong can still be read after the app is restarted.
export default (app) => {
  const id = "clientLog";
  let entries = [];
  let loaded = false;

  app.on("clientLog", ({ message, ...details }) => {
    entries = [...entries, { time: Date.now(), message, ...details, connected: app.connection.connected, ...app.connection.state() }].slice(-1000);
    if (loaded) app.storage.setItemDebounce({ id, value: entries, delay: 1000 });
  });
  app.on("clientLogEntries", () => ({ entries }));
  app.on("clientLogClear", () => {
    entries = [];
    app.storage.setItem({ id, value: entries });
  });

  app.on("init", 1000, async () => {
    const { value } = await app.storage.getItem({ id });
    entries = [...(value || []), ...entries].slice(-1000);
    loaded = true;
    const { appVersion } = await app.event("getAppVersion");
    app.event("clientLog", { message: "App started", appVersion, standalone: navigator.standalone, userAgent: navigator.userAgent });
  });

  // A wait query only asks for the current state; it is not a change.
  app.connection.on("connection", -100, ({ wait, connected, fallback, error }) => {
    if (wait) return;
    app.event("clientLog", { message: `Connection ${connected ? "up" : "down"}`, fallback, error: error && true });
  });

  document.addEventListener("visibilitychange", () => app.event("clientLog", { message: `Page ${document.visibilityState}` }));
  window.addEventListener("pageshow", ({ persisted }) => app.event("clientLog", { message: "Page show", persisted }));
  window.addEventListener("pagehide", ({ persisted }) => app.event("clientLog", { message: "Page hide", persisted }));
  window.addEventListener("online", () => app.event("clientLog", { message: "Browser online" }));
  window.addEventListener("offline", () => app.event("clientLog", { message: "Browser offline" }));
};
